<div class="topbar">
  <div>
    <h1>Indstillinger for Postnummer</h1>
  </div>
  <div class="topbar__actions">
    @if (dataSource.length > 0 && shownNumbers < dataSource.length) {
      <small>
        Viser {{ shownNumbers }}
        <span>af {{ dataSource.length }}</span>
      </small>
    }

    @if (dataSource.length > 0 && shownNumbers > dataSource.length) {
      <small>
        Viser {{ dataSource.length }}
        <span>af {{ dataSource.length }}</span>
      </small>
    }
    <button class="btn-icon" [matTooltip]="'Download postnummer listen som excel ark'">
      <mat-icon svgIcon="download" class="icon-32" (click)="download()"></mat-icon>
    </button>
    @if (canEdit) {
      <button
        (click)="edit()"
        class="btn-icon green"
        aria-label="Tilføj partner til postnummer"
        matTooltip="Tilføj partner til postnummer"
        >
        <mat-icon svgIcon="add"></mat-icon>
        <span>Tilføj</span>
      </button>
    }
    @if (canEdit) {
      <button
        (click)="remove()"
        class="btn-icon red"
        aria-label="Fjern partner fra postnummer"
        matTooltip="Fjern partner fra postnummer"
        >
        <mat-icon svgIcon="remove"></mat-icon>
        <span>Fjern</span>
      </button>
    }

    <form [formGroup]="form" autocomplete="off">
      <div class="search-wrap">
        <mat-form-field appearance="outline" color="accent">
          <mat-label>Fra</mat-label>
          <input type="number" matInput number formControlName="searchFra" [min]="1000" [max]="10000" />
        </mat-form-field>
        <mat-form-field appearance="outline" color="accent">
          <mat-label>Til</mat-label>
          <input type="number" matInput number formControlName="searchTil" [min]="1000" [max]="10000" />
        </mat-form-field>
        <button class="btn-icon" color="accent" matTooltip="Søg" (click)="onSearch()">
          <mat-icon svgIcon="search"></mat-icon>
        </button>
      </div>
    </form>
  </div>
</div>
<div class="page__content settings">
  <div class="settings__wrap">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z0 settings__table">
      <ng-container matColumnDef="postnummer">
        <th mat-header-cell *matHeaderCellDef>Postnummer</th>
        <td mat-cell *matCellDef="let row">
          {{ row.postnummer }}
        </td>
      </ng-container>
      <ng-container matColumnDef="partner">
        <th mat-header-cell *matHeaderCellDef>Partnere</th>
        <td mat-cell *matCellDef="let row">
          @for (element of row.partnere; track element) {
            <div>
              @if (produktIkon(element.produkt) != 'gasstorbraender' && isValidPartner(element.validTo)) {
                <div
                  class="display flex align-items center"
                  >
                  <mat-icon [svgIcon]="produktIkon(element.produkt)"></mat-icon>
                  <span [matTooltip]="getPartnerAllowFrieTilkald(element)">{{ element.name }}</span>
                </div>
              }
              @if (produktIkon(element.produkt) == 'gasstorbraender' && isValidPartner(element.validTo)) {
                <div
                  class="display flex align-items center"
                  >
                  <mat-icon svgIcon="gas"></mat-icon>
                  (Storbrænder)
                  <span [matTooltip]="getPartnerAllowFrieTilkald(element)">{{ element.name }}</span>
                </div>
              }
            </div>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="senestePartner">
        <th mat-header-cell *matHeaderCellDef>Seneste partner</th>
        <td mat-cell *matCellDef="let row">
          @if (latestPartner(row).length != 0) {
            <div>
              @for (partner of latestPartner(row); track partner) {
                <div>
                  @if (produktIkon(partner.produkt) != 'gasstorbraender') {
                    <div class="display flex align-items center">
                      <mat-icon svgIcon="{{ produktIkon(partner.produkt) }}"></mat-icon>
                      {{ partner.name }}
                    </div>
                  }
                  @if (produktIkon(partner.produkt) == 'gasstorbraender') {
                    <div class="display flex align-items center">
                      <mat-icon svgIcon="gas"></mat-icon>
                      (Storbrænder)
                      {{ partner.name }}
                    </div>
                  }
                </div>
              }
            </div>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="dato">
        <th mat-header-cell *matHeaderCellDef>Dato for skift</th>
        <td mat-cell *matCellDef="let row">
          @if (latestPartner(row).length != 0) {
            <div class="display flex align-items center">
              {{ latestPartner(row)[0].validTo | date : 'dd-MM-yyyy' }}
            </div>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</div>
